
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14 5h4c1.093 0 2 .907 2 2v1h6c1.645 0 3 1.355 3 3v15H3V11c0-1.645 1.355-3 3-3h6V7c0-1.093.907-2 2-2zm0 2v1h4V7h-4zm-8 3c-.565 0-1 .435-1 1v13h22V11c0-.565-.435-1-1-1H6zm9 3h2v3h3v2h-3v3h-2v-3h-3v-2h3v-3z"}})])
          )
        }
      }
    